import React from "react";
import { APP_VERSION, APP_BUILD, APP_CODENAME } from "@/lib/version";

/**
 * Fixed build/version badge pinned to the bottom-left of the viewport on EVERY
 * page. Same visual format as the former inline VersionFooter (env pill +
 * semver + build + codename) — just relocated to a fixed overlay so it stays
 * put while scrolling and never scrolls away with page content.
 *
 * `pointer-events-none` guarantees it can never block a click / button / nav,
 * and it is offset to clear the admin bottom-left help FAB and the mobile
 * bottom navigation bars.
 *
 * Detection is host-based — `teleadmin.in` is Prod, everything else is Preview.
 */
export default function GlobalVersionBadge() {
    const isProd = typeof window !== "undefined" && window.location.hostname === "teleadmin.in";
    return (
        <div
            data-testid="app-version-footer"
            className="pointer-events-none fixed bottom-20 left-3 z-30 flex items-center gap-1.5 rounded-full bg-white/85 px-2.5 py-1 text-[11px] text-slate-400 shadow-sm ring-1 ring-slate-200 backdrop-blur-sm sm:gap-3 md:bottom-3 md:left-16"
        >
            <span
                data-testid="env-badge"
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-wider ${
                    isProd
                        ? "bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200"
                        : "bg-amber-100 text-amber-700 ring-1 ring-amber-200"
                }`}
            >
                <span className={`h-1.5 w-1.5 rounded-full ${isProd ? "bg-emerald-500" : "bg-amber-500"}`} />
                {isProd ? "Prod" : "Preview"}
            </span>
            <span className="hidden sm:inline">·</span>
            <span className="font-mono">
                MICM <span className="font-semibold text-slate-500">v{APP_VERSION}</span>
            </span>
            <span className="hidden sm:inline">·</span>
            <span className="hidden font-mono sm:inline">build {APP_BUILD}</span>
            <span className="hidden sm:inline">·</span>
            <span className="hidden italic sm:inline">{APP_CODENAME}</span>
        </div>
    );
}
